import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  snapDefaultClientDetail,
  unSnapDefaultClientDetail,
} from "store/user/(default)/client/default_client.action";
import {
  snapDefaultBailiff,
  unSnapDefaultBailiff,
} from "store/bailiff/draft/bailiff/default_bailiff.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  const params = useParams();
  const clientId = params?.clientId;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  // snap detail client
  useEffect(() => {
    if (clientId) {
      dispatch(snapDefaultClientDetail({ clientId }));
    }

    return () => dispatch(unSnapDefaultClientDetail());
  }, [clientId, dispatch]);

  useEffect(() => {
    if (clientId) {
      dispatch(snapDefaultBailiff({ clientId }));
    }

    return () => dispatch(unSnapDefaultBailiff());
  }, [clientId, dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
